import { colors } from '@/constants/colors';
import React from 'react';
import styled from 'styled-components';

interface Props {
   title: string;
}

const SectionTitle = ({ title }: Props) => {
   return (
      <Wrapper>
         <Title>{title}</Title>
      </Wrapper>
   );
};

const Wrapper = styled.div`
   margin-bottom: 1rem;
`;
const Title = styled.p`
   font-size: 22px;
   font-weight: 700;
   color: ${colors.GRAY_DARK};
`;

export default SectionTitle;
